import styled, { css } from 'styled-components'
import { colors } from '../../../../styles/constants'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid #DADADA;
  min-height: calc(100vh - 88px);
`
export const MenuList = styled.ul`
  min-width: 180px;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
`
export const ListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 16px;
  list-style-type: none;

  :hover {
    background-color: #D8EEF6;
    cursor: pointer;
  }
`
export const Link = styled.a`
  color: ${colors.gray.darker};
  display: flex;
  align-items: flex-end;
  position: relative;

  :hover {
    text-decoration: none;
    color: ${colors.gray.darker};
  }

  ${({ active }) => active && css`
    svg path {
      fill: #028BB7;
    }
  `}
`
export const Title = styled.span`
  color: #555;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23.2px;
  margin-left: 4px;

  ${({ active }) => active && css`
    color: #028BB7;
  `}
`
export const ButtonLogout = styled.button`
  display: flex;
  background: transparent;
  width: 100%;
  padding: 8px 16px;
  margin-bottom: 16px;
  border: none;
  color: #555;
  font-family: 'Open Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23.2px;
  gap: 4px;
`

export const NotificationsCount = styled.span`
  width: 15px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  color: #fff;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 12px;
  position: absolute;
  top: -3px;
  right: 50%;
  margin-right: -27px;
  background-color: #FF8200;
  border-radius: 50%;

  ${(isDesktop) => isDesktop && css`
      left: 10px;
      right: 0;
  `}
`
